import Vue from 'vue';
import i18n from '@/i18n';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
